import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"
import ScrollReveal from "scrollreveal"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();


    function buildFormat() {
      var $toc = $('<div />', {id: 'toc_container'});
      var $list = $('<ul />', {class: 'toc_list'});
      var $groups = $('.u-format-group');
      // フォーマットグループごとの処理
      for (var i = 0; i < $groups.length; i++) {
        var $_list = $('<ul />');
        var $group = $($groups[i]);
        var group_title = $group.find('.u-format-group__title').text();
        var $group_li = $('<li />');
        var groupid = 'formatgroup_' + (i + 1);
        $group.attr('id', groupid);
        $list.append(
          $group_li.append(
            $('<a />',
              {
                text: (i + 1) + '. ' + group_title,
                href: '#' + groupid
              }
            )
          )
        );
        // フォーマットごとの処理
        var $formats = $group.find('.u-format-group__content').find('.u-format');
        var $_ul = $('<ul />');
        for (var m = 0; m < $formats.length; m++) {
          var $format = $($formats[m]);
          var $format_title = $format.find('.u-format__title');
          var $format_content = $format.find('.u-format__content');
          var formatid = 'format_' + (i + 1) + (m + 1);
          $format.find('.u-format__title').attr('id', formatid);
          var format_title = $format_title.text();
          var format_number = (i + 1) + '.' + (m + 1) + '. ';
          $format_title.text(format_number + format_title);
          $_ul.append(
            $('<li />').append(
              $('<a />', {
                  href: '#' + formatid,
                  text: format_number + format_title
                }
              )
            )
          );

          // コードを追加
          var $code = $('<div />', {class: 'u-format__code'});
          $code.append($('<div />', {
            class: 'u-format__code__title',
            text: format_number + format_title
          }));
          var formathtml = $format.find('.u-format__content').html();
          $code.append($('<pre />', {text: formathtml.trim()}));
          $format.append($code);
        }
        $group_li.append($_ul);
        $_list.append($group_li);
        $list.append($_list);
      }
      $toc.append($list);
      $('.c-breadcrumb').after(
        $('<div />', {
            class: 'l-container'
          }
        ).append($toc)
      );
    }

    $(function() {
        var owls = $('.owl-carousel');
        if (owls.length === 0) {
            return false
        }
        owls.imagesLoaded(function () {
            $('.c-case-slider .owl-carousel').owlCarousel({
                items: 4,
                margin: 16
            });
            $('.c-main-visual__slider').owlCarousel({
                items: 1,
                margin: 0,
                dots: true,
                loop: true,
                nav: false,
                autoplayHoverPause: true,
                //autoplay: true,
                autoplaySpeed: 500,
                center: true,
                navText: ['<img src="/assets/images/icon-slider-prev.svg" />','<img src="/assets/images/icon-slider-next.svg" />'],
            });
        });
      buildFormat();
    });
  }
}

window.GApp = new App();





(function ($) {

    var growApp = function () {
    };
    /*
     * userAgent取得
     * */
    var Agent = window.navigator.userAgent.toLowerCase();
    var _ua = (function (u) {
        return {
            Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
            || u.indexOf("ipad") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
            || u.indexOf("kindle") != -1
            || u.indexOf("silk") != -1
            || u.indexOf("playbook") != -1,
            Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
            || u.indexOf("iphone") != -1
            || u.indexOf("ipod") != -1
            || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
            || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
            || u.indexOf("blackberry") != -1
        }
    })(Agent);

    growApp.prototype.changeViewPort = function () {

        //ビューポート処理
        if (_ua.Mobile) {
            $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
        } else {
            $('head').prepend('<meta name="viewport" content="width=1100">');
        }
    };

    /*
    *
    * スマホメニューの高さを取得する
    *
    * */
    growApp.prototype.menuHight = function () {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }

        var $smpHeaderHeight = $('.l-header').height();
        var windowHeight = window.innerHeight;
        var winH = windowHeight - $smpHeaderHeight;

        console.log($smpHeaderHeight);

        //動かすターゲットを取得
        var targetSlidebarWrap = $('.c-slidebar-menu'),
            targetSlidebarMenu = $('.c-slidebar__parent'),
            targetSlidebarBtn = $('.c-slidebar-menu__parent');


        //いざ実行(クリックしたら処理を実行する)
        targetSlidebarBtn.on('click', function () {
            $('.c-slidebar-menu').toggleClass('is-active');

        });

    }

    growApp.prototype.footerMenu = function () {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }
        $(".c-footer-menu__title.is-parent").on("click",function(e){
            e.preventDefault();
        });
        $(".c-footer-menu__title.is-parent").on('click',function() {
            $(this).toggleClass('is-open');
            $(this).next(".c-footer-menu__list.is-sub").slideToggle();
        })
    }

    growApp.prototype.sideMenu = function () {
        var $button = $("#sidebar .c-sidebar__list .is-parent li");
        $button.on("click",function(){
            $(this).next(".is-child").slideToggle();
            $(this).stop(true).toggleClass("is-active");
        })
    }

    //ボタンテキスト変更
    growApp.prototype.spMeueText = function(){
        var $btn = $(".c-slidebar-button");
        var $btnText = $(".c-slidebar-button__text");
        $btn.on("click",function(){
            var $text = $btnText.text();
            if($text === "MENU" ){
                $btnText.text("閉じる");
            }else{
                $btnText.text("MENU");
            }
        })
    }
    //ボタンテキスト変更
    growApp.prototype.navSearch = function(){
        $("#search-btn,#search-btn-sp").on("click",function(){
            $("#search-box").fadeIn();
            $(".c-search-nav").toggleClass("is-active");
        });
        $("#search-close").on("click",function(){
            $("#search-box").fadeOut();
            $(".c-search-nav").removeClass("is-active");
        });
    }
    growApp.prototype.ScrollReveal = function(){
        window.sr = ScrollReveal({duration: 600,mobile:false});
        function domEach(items, callback) {
            if (typeof items === "string") {
                var items = $(items);
            }
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                // callback = callback.bind(item)
                callback(i, item);
            }
        }

        //mainVisual
        sr.reveal(".c-main-visual", {scale: 1, duration: 1600,origin:'bottom',distance: '50px',}, 100);
        //top
        sr.reveal(".c-top-sanwa__text-sanwa", {scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);
        sr.reveal(".c-top-sanwa__lead-block", {delay: 400, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);
        sr.reveal(".c-top-sanwa__button-block", {delay: 400, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);


        sr.reveal(".c-title-block,.c-pick-up__pickup-block,.c-top-overview,.c-top-post-block,.c-online-shop", {scale: 1, duration: 2000, origin: 'bottom', distance: '30px',}, 100);
        sr.reveal(".c-top-products__button.health", {delay: 400, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);
        sr.reveal(".c-top-products__button.safty", {delay: 600, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);
        sr.reveal(".c-top-products__button.education", {delay: 800, scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);

        //lower
        sr.reveal(".c-page-header__inner,.c-lower-title", {scale: 1, duration: 2000, origin: 'bottom', distance: '20px',}, 100);
        //history
        sr.reveal(".c-history-top,.c-mission-logo", {scale: 1, duration: 2000, origin: 'bottom', distance: '50px',}, 100);

    }

    // navにis-currentを付与
    growApp.prototype.navProduct = function(){
        var hash = location.hash ; //#以降を取得
        var url = location.href ; //urlを取得
        var href = "";
        var $nav = $(".js-tabs-origin-nav ul li a");
        //初期処理
        $(".js-tabs-origin-nav ul li:first-child a").addClass("is-active");
        //#以降があった場合
        if(hash){
            var dir = url.split("/"); // /で区切る
            dir = dir[dir.length -2]; // 配列の末尾2個目を取得
            $nav.each(function(){
                var href = $(this).attr("href");
                href = href.split("/");
                href = href[href.length -2];
                //初期処理
                $(this).removeClass("is-active");
                // リンクのディレクトリと一致したら
                if(dir == href){
                    $(this).addClass("is-active");
                }
            });
        }
    }

    $(function () {
        var app = new growApp();
        //app.changeViewPort();
        // app.menuHight();
        app.footerMenu();
        app.sideMenu();
        app.spMeueText();
        app.navSearch();
        app.ScrollReveal();
        app.navProduct();

    });

})(jQuery);

